module.exports = __webpack_public_path__ + "static/CTA-image-0ae9c5b69630e96209c597467c69e5c2.png";